import React, {createContext, useContext, useRef} from "react";
import {Modal} from "antd";
import {HookAPI} from "antd/lib/modal/useModal";

type Context = {
	api: HookAPI;
}

const ModalContext = createContext({} as Context)

export const ModalProvider = ({children}: { children: React.ReactNode }) => {
	const audioPlayer = useRef(null);

	const playModalSound = () => {
		if (audioPlayer.current)
		{
			// @ts-ignore
			audioPlayer.current.play();
		}
	}

	const [api, contextHolder] = Modal.useModal();

	const context: Context = {api}

	return <ModalContext.Provider value={context}>
		{contextHolder}
		{children}
	</ModalContext.Provider>
}

export const useModal = () => {
	const context = useContext(ModalContext);
	return [context.api, context] as [Context['api'], Context];
}